import styled, { css } from "styled-components"

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    &__filter {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      width: 100%;
    }

    &__nav {
      display: flex;
      justify-content: space-between;
      height: 40px;
      width: 100%;
    }

    &__switch {
      align-items: center;
      display: flex;
      height: 100%;
    }

    &__buttons {
      display: flex;
    }
  }

  .body_history {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .body {
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    .centerCell {
      justify-content: center;
      align-items: center;
      display: flex;
    }

    .cellFullSize {
      position: relative;
      height: 100%;
      width: 100%;
    }

    .textOverflowCell {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .flexWrap {
      white-space: pre-wrap;
      text-align: center;
    }

    &__buttons {
      justify-content: flex-end;
      align-items: center;
      display: flex;
      width: 100%;
    }

    &__button {
      box-shadow: 1px 1px 6px #707070;
      transition: 0.25s ease-in;
      justify-content: center;
      align-items: center;
      background: #f3f3f3;
      margin: 0 0 0 10px;
      border-radius: 50%;
      font-size: 0.8rem;
      cursor: pointer;
      color: #707070;
      display: flex;
      height: 30px;
      width: 30px;

      &:hover {
        transition: transform 0.25s ease-out;
        transform: scale(1.2);
      }
    }
  }

  ${({ isTablette }) => isTablette && css``}

  ${({ isMobile }) => isMobile && css``}
`

export const SwitchItem = styled.div`
  color: ${({ primaryActionColor }) => primaryActionColor || "#858585"};
  text-transform: uppercase;
  justify-content: center;
  font-weight: bold;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0 25px;
  display: flex;
  border-right: ${({ primaryActionColor }) =>
    primaryActionColor ? `1px solid ${primaryActionColor}` : "1px solid navy"};

  :last-child {
    border: none;
  }

  &:hover {
    div {
      transition: 0.25s ease-in;
      &:hover {
        transition: transform 0.25s ease-out;
        transform: scale(1.1);
      }
    }
  }

  ${({ isActive }) =>
    !isActive &&
    css`
      opacity: 0.6;

      &:hover {
        opacity: 1;
      }
    `}
`

export const ContainerBubble = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 0.5rem;
  margin: 5px 0;
`

export const BubbleExample = styled.p`
  font-size: 0.8rem;
  border-radius: 40px 0;
  background-color: ${({ backgroundColor }) => backgroundColor || "orange"};
  min-width: 100px;
  height: 30px;
  color: ${({ color }) => color || "white"}!important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer !important;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  line-height: 30px;
  -webkit-box-orient: vertical;
  width: 100px;
  padding: 0 10px;
`

export const OptionButtons = styled.div`
  box-shadow: 1px 1px 6px #707070;
  background-color: #f3f3f3;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  color: #707070;
  display: flex;
  height: 30px;
  width: 30px;
`

export const TableColumsOption = styled.div`
  overflow: none;
  height: auto;
  width: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: 1fr 1fr;
`

export const HistoryContainer = styled.div`
  grid-template-columns: repeat(auto-fit, 280px);
  grid-template-rows: repeat(auto-fit, 300px);
  justify-content: center;
  margin: 0 0 7.5px 0;
  overflow: auto;
  display: grid;
  height: 100%;
  gap: 20px;

  ${({ length }) =>
    length &&
    css`
      justify-content: center;
      align-items: center;
      display: flex;
      height: 100%;
      width: 100%;
    `}
`
